<page-toolbar title="{{'analytic.title' | translate}}"></page-toolbar>

<data-table *ngIf="data" [plainData]="data" [columns]="columns" [newHeader]="true" [searchAll]="true"></data-table>
